/**
 * Result type for functional error handling
 * Provides a type-safe way to handle success/failure without exceptions
 */
/**
 * Creates a successful result
 */
export const ok = (value) => ({ success: true, value });
/**
 * Creates a failed result
 */
export const err = (error) => ({ success: false, error });
/**
 * Type guard to check if a Result is Ok
 */
export const isOk = (result) => result.success;
/**
 * Type guard to check if a Result is Err
 */
export const isErr = (result) => !result.success;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVzdWx0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Jlc3VsdC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTs7O0dBR0c7QUFpQkg7O0dBRUc7QUFDSCxNQUFNLENBQUMsTUFBTSxFQUFFLEdBQUcsQ0FBSSxLQUFRLEVBQVMsRUFBRSxDQUFDLENBQUMsRUFBRSxPQUFPLEVBQUUsSUFBSSxFQUFFLEtBQUssRUFBRSxDQUFDLENBQUM7QUFFckU7O0dBRUc7QUFDSCxNQUFNLENBQUMsTUFBTSxHQUFHLEdBQUcsQ0FBSSxLQUFRLEVBQVUsRUFBRSxDQUFDLENBQUMsRUFBRSxPQUFPLEVBQUUsS0FBSyxFQUFFLEtBQUssRUFBRSxDQUFDLENBQUM7QUFFeEU7O0dBRUc7QUFDSCxNQUFNLENBQUMsTUFBTSxJQUFJLEdBQUcsQ0FBTyxNQUFvQixFQUFtQixFQUFFLENBQUMsTUFBTSxDQUFDLE9BQU8sQ0FBQztBQUVwRjs7R0FFRztBQUNILE1BQU0sQ0FBQyxNQUFNLEtBQUssR0FBRyxDQUFPLE1BQW9CLEVBQW9CLEVBQUUsQ0FBQyxDQUFDLE1BQU0sQ0FBQyxPQUFPLENBQUMifQ==